import OnlyHeader from "components/Headers/OnlyHeader";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import firebase from "../config/firebase";
import { useDispatch, useSelector } from "react-redux";
import { addManagersRequests } from "store/actions/managerAction";
import { fetchManagersRequests } from "store/actions/managerAction";
import moment from "moment";
import { deleteRequest } from "store/actions/managerAction";
import { editRequest } from "store/actions/managerAction";

const ManagerTech = () => {
  let dispatch = useDispatch();
  const [loader, setLoader] = useState({
    data: false,
    btn: false,
    loaderMore: false,
  });
  const [data, setData] = useState({
    details: "",
  });
  const [requestModal, setRequestModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [collectionId, setCollectionId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  let { uid, user } = useSelector((state) => state.auth);
  let { requests, lastDocument, hasMore } = useSelector(
    (state) => state.manager
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const deleteModalToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const createRequestModal = () => {
    setRequestModal(!requestModal);
  };
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      fetchManagersRequests(uid, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);
  const loadMore = () => {
    setLoader((prev) => ({
      ...prev,
      loaderMore: true,
    }));
    dispatch(
      fetchManagersRequests(uid, lastDocument, () => {
        setLoader((prev) => ({
          ...prev,
          loaderMore: false,
        }));
      })
    );
  };

  const submitData = (e) => {
    e.preventDefault();
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    if (isEdit) {
      let requestData = {
        requestDetail: data.details,
      };
      dispatch(
        editRequest(collectionId, requestData, (res) => {
          setLoader((prev) => ({
            ...prev,
            btn: false,
          }));
          if (res == "success") {
            createRequestModal();
            setIsEdit(false);
            setData((prev) => ({
              ...prev,
              details: "",
            }));
          }
        })
      );
    } else {
      let requestData = {
        requestDetail: data.details,
        requestedId: uid,
        created_at: firebase.firestore.Timestamp.now(),
        type: user.type == "school platform" ? "school" : "collective",
      };
      dispatch(
        addManagersRequests(requestData, (res) => {
          setLoader((prev) => ({
            ...prev,
            btn: false,
          }));
          if (res == "success") {
            createRequestModal();
            setData((prev) => ({
              ...prev,
              details: "",
            }));
          }
        })
      );
    }
  };
  return (
    <>
      <OnlyHeader />

      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0 whitespace-nowrap">Seeking Manager</h3>
                <div className="d-flex  justify-content-center align-items-center">
                  <Button
                    color="primary"
                    onClick={() => {
                      setIsEdit(false);
                      createRequestModal();
                      setData((prev) => ({
                        ...prev,
                        details: "",
                      }));
                    }}
                    className="whitespace-nowrap"
                  >
                    Create Request
                  </Button>
                </div>
              </CardHeader>
              {loader.data ? (
                <div className="text-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Request Detail</th>
                      <th scope="col">Created At</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requests.length > 0 ? (
                      requests.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.requestDetail}</td>
                            <td>
                              {moment
                                .unix(item.created_at.seconds)
                                .format("DD MMM YYYY")}
                            </td>
                            <td>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  deleteModalToggle();
                                  setCollectionId(item.id);
                                }}
                              >
                                Delete
                              </Button>
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => {
                                  setCollectionId(item.id);
                                  setIsEdit(true);
                                  createRequestModal();
                                  setData((prev) => ({
                                    ...prev,
                                    details: item.requestDetail,
                                  }));
                                }}
                              >
                                Edit
                              </Button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
              {requests.length > 4 && (
                <div className="text-center">
                  <Button
                    color="primary"
                    onClick={loadMore}
                    disabled={!hasMore || loader.loaderMore}
                  >
                    {loader.loaderMore ? <Spinner /> : "Load More"}
                  </Button>
                </div>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={requestModal} toggle={createRequestModal} size="md">
        <ModalBody className="px-1 px-md-2">
          <Form onSubmit={submitData}>
            <Container>
              <h1 className="text-center mb-4">Want Manager To Teach You?</h1>
              <FormGroup>
                <Label for="detail">Request Details</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="detail"
                    placeholder="Add Request Details"
                    type="textarea"
                    value={data.details}
                    onChange={handleChange}
                    name="details"
                    required
                  />
                </InputGroup>
              </FormGroup>
            </Container>
            <div className="text-right mt-4 px-2">
              <Button color="danger" onClick={createRequestModal}>Cancel</Button>
              <Button color="primary" type="submit">
                {loader.btn ? (
                  <Spinner size="sm" />
                ) : isEdit ? (
                  "Upgrade"
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={deleteModal} centered toggle={deleteModalToggle}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to delete Request.
            </span>
            <br />
            <br />
            <br />
            <Button color="danger" onClick={deleteModalToggle}>
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                setLoader((prev) => ({
                  ...prev,
                  btn: true,
                }));
                dispatch(
                  deleteRequest(collectionId, () => {
                    deleteModalToggle();
                    setLoader((prev) => ({
                      ...prev,
                      btn: false,
                    }));
                  })
                );
              }}
            >
              {loader.btn ? <Spinner size="sm" /> : "Delete"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ManagerTech;
